import React from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import Modal from '../../../../core/modules/common/components/Modal';
import DownloadModal from '../../../../core/modules/common/components/DownloadModal';

const XlsExportModal = (props) => {
  const {
    downloadReport,
    closeModal,
  } = props;
  return (
    <Modal
      header={
        <FormattedMessage
          id="app.warning.download.limitation"
          tagName="h5"
        />
      }
      closeOnOutsideClick
      onClose={closeModal}
    >
      <DownloadModal
        downloadReport={downloadReport}
        closeModal={closeModal}
      />
    </Modal>
  );
};

XlsExportModal.propTypes = {
  downloadReport: PropTypes.func.isRequired,
  closeModal: PropTypes.func.isRequired,
};

export default XlsExportModal;
